package com.merkost.handpass.api.dto.admin

import com.merkost.handpass.api.dto.report.ReportResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminListingDetail(
    val id: String,
    val title: String,
    val description: String? = null,
    @SerialName("price_cents") val priceCents: Long,
    val currency: String,
    val status: String,
    val condition: String? = null,
    @SerialName("category_id") val categoryId: String? = null,
    @SerialName("category_name") val categoryName: String? = null,
    @SerialName("seller_id") val sellerId: String? = null,
    @SerialName("seller_name") val sellerName: String? = null,
    @SerialName("seller_email") val sellerEmail: String? = null,
    @SerialName("seller_avatar_url") val sellerAvatarUrl: String? = null,
    @SerialName("image_urls") val imageUrls: List<String> = emptyList(),
    @SerialName("created_at") val createdAt: String,
    @SerialName("updated_at") val updatedAt: String? = null,
    @SerialName("reports") val reports: List<ReportResponse> = emptyList(),
    @SerialName("moderation_history") val moderationHistory: List<ModerationLogEntry> = emptyList(),
    @SerialName("suburb") val suburb: String? = null,
    @SerialName("city") val city: String? = null,
    @SerialName("state") val state: String? = null,
)
